import getFieldsByName from './getFieldsByName';

/**
 * Gets the first field in an element (eg. form or panel) with the specified name attribute,
 * ignoring incomplete and inactive panels.
 *
 * @param {Element} element
 * @param {Element} name
 */
export default function getFieldByName(element, name) {
  return getFieldsByName(element, name)[0];
}
